module.exports = __webpack_public_path__ + "static/Group5993@2x-35e24706217f67f9a8fa0a088167a5c4.png";